module.exports = __webpack_public_path__ + "static/media/icoAttachment.d6119683.svg";